export const normalizeCallbackError = (message: string) => {
  if (message === "forbidden") {
    return { errorType: "FORBIDDEN" };
  } else if (message === "klarna checkout mismatch") {
    return { errorType: "KLARNA_CHECKOUT_MISMATCH" };
  } else if (message === "could not acquire checkout id lock, try again later.") {
    return { errorType: "COULD_NOT_ACQUIRE_CHECKOUT_ID_LOCK" };
  } else if (message.match(/max capacity exceeded for event_id=([0-9]+)/)) {
    return { errorType: "MAX_CAPACITY_EXCEEDED_FOR_EVENT" };
  } else if (
    message.match(/could not allocate ticket with ticket_type_id=([0-9]+), event_id=([0-9]+)/)
  ) {
    return { errorType: "COULD_NOT_ALLOCATE_TICKET_TYPE", ticketTypeId: 1 };
  } else if (message.match('allocation capacity exceeded for allocation "([0-9]+)"')) {
    return { errorType: "ALLOCATION_CAPACITY_EXCEEDED" };
  } else if (
    message.match(
      'allocation capacity exceeded for ticket type "([0-9]+)" in allocation "([0-9]+)"',
    )
  ) {
    return { errorType: "ALLOCATION_CAPACITY_EXCEEDED_FOR_TICKET_TYPE", ticketTypeId: 1 };
  } else if (message.match("No such checkout of id (.+)")) {
    return { errorType: "UNKNOWN_CHECKOUT_ID" };
  } else {
    return { errorType: "GENERIC" };
  }
};
